export default __webpack_public_path__ + "static/question_illustration-a2fa334923c8e90fab210724028b0c8c.svg";